import * as React from 'react';

import { Pagination } from '../../../components/admin/Pagination';
import { useSelector } from 'react-redux';
import { selectProjects } from 'shared/selectors/admin/projects';
import { selectLimit } from 'shared/selectors/admin/limit';
import { selectPage } from 'shared/selectors/admin/page';
import { useAppDispatch } from 'shared/hooks';
import { setPage } from 'shared/slices/admin/page/pageSlice';
import { loadProjects } from 'shared/thunks/admin';

export const PaginationContainer: React.FC = () => {
  const { total } = useSelector(selectProjects);
  const limit = useSelector(selectLimit);
  const page = useSelector(selectPage);

  const dispatch = useAppDispatch();

  const onPageChange = React.useCallback(
    (page: number) => {
      dispatch(setPage(page));
      dispatch(loadProjects());
    },
    [dispatch],
  );

  if (total <= limit) {
    return null;
  }

  return <Pagination totalPages={Math.ceil(total / limit)} currentPage={page} onPageChange={onPageChange} />;
};
